import { useEffect, useRef, useState } from "react";
import type { LogRow } from "../types/api";
import { humanizeLogSummary, humanizeLogType } from "../utils/liveStatus";

interface ActivityLogProps {
  rows: LogRow[];
  eventCount: number;
  connecting?: boolean;
}

export function ActivityLog({ rows, eventCount, connecting }: ActivityLogProps) {
  const bodyRef = useRef<HTMLDivElement>(null);
  const [autoScroll, setAutoScroll] = useState(true);

  useEffect(() => {
    if (autoScroll && bodyRef.current) {
      bodyRef.current.scrollTop = bodyRef.current.scrollHeight;
    }
  }, [rows, autoScroll]);

  const handleScroll = () => {
    const el = bodyRef.current;
    if (!el) return;
    const atBottom = el.scrollHeight - el.scrollTop - el.clientHeight < 24;
    setAutoScroll(atBottom);
  };

  return (
    <div className="activity-log">
      <div className="activity-log-hdr">
        <span>Activity log</span>
        <span className="activity-log-meta">
          live · {eventCount} events
        </span>
      </div>
      <div className="activity-log-body" ref={bodyRef} onScroll={handleScroll}>
        {connecting && rows.length === 0 ? (
          <div className="log-row log-default">
            <span className="log-ts">--:--:--</span>
            <span className="log-type">connecting</span>
            <span className="log-data">…</span>
          </div>
        ) : null}
        {rows.map((row) => (
          <div key={row.id} className={`log-row log-${row.tone}`}>
            <span className="log-ts">{row.timestamp}</span>
            <span className="log-type">{humanizeLogType(row.type)}</span>
            <span className="log-data">
              {humanizeLogSummary(row)}
              {row.done ? " ✓" : row.type === "tool_running" || row.type === "tool_start" ? " …" : ""}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
